import { useState, useEffect } from "react";
import { toast } from "sonner";
import { Smile } from "lucide-react";
import api from "../lib/api";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { MOODS, moodMeta } from "./Mood";

export const MoodButton = () => {
  const [open, setOpen] = useState(false);
  const [mood, setMood] = useState(null);

  useEffect(() => {
    api.get("/me/mood").then(({ data }) => setMood(data.mood), () => setMood(null));
  }, []);

  const pick = async (key) => {
    const next = key === mood ? "" : key;
    try {
      const { data } = await api.put("/me/mood", { mood: next });
      setMood(data.mood);
      toast.success(data.mood ? "Dank je, je organisatie weet nu hoe het met je gaat" : "Je status is gewist");
    } catch {
      toast.error("Opslaan mislukt");
    }
  };
  const m = moodMeta(mood);

  return (
    <>
      <Button variant="outline" className="rounded-none h-9" onClick={() => setOpen(true)} data-testid="mood-button">
        {m ? <span className={`h-2.5 w-2.5 rounded-full mr-2 ${m.dot}`} /> : <Smile className="h-4 w-4 mr-2" />} Hoe gaat het?
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="rounded-none max-w-md" data-testid="mood-dialog">
          <DialogHeader>
            <DialogTitle className="font-grotesk">Hoe gaat het met je?</DialogTitle>
            <DialogDescription>Laat de organisatie weten hoe je je op dit moment voelt.</DialogDescription>
          </DialogHeader>
          <div className="grid grid-cols-3 gap-2">
            {MOODS.map((o) => (
              <button key={o.key} type="button" onClick={() => pick(o.key)} data-testid={`mood-option-${o.key}`}
                className={`flex flex-col items-center gap-2 border px-3 py-4 text-sm transition-colors ${mood === o.key ? "border-zinc-900 bg-zinc-900 text-white" : "border-zinc-300 hover:border-zinc-900"}`}>
                <span className={`h-3 w-3 rounded-full ${o.dot}`} />
                {o.label}
              </button>
            ))}
          </div>
          <p className="text-xs text-zinc-500 leading-relaxed" data-testid="mood-disclaimer">
            Neutraal betekent: noch gestresst, noch ontspannen. Je hoeft hier niet de werkelijkheid in te vullen; het is prima als je iets anders kiest.
            Dit is er alleen zodat je de organisatie kunt laten weten hoe het met je gaat, als je dat wilt. Alleen beheerders, consultants,
            kijkers en je (senior of junior) management zien je keuze. Klik nogmaals op je keuze om die te wissen.
          </p>
        </DialogContent>
      </Dialog>
    </>
  );
};
